import { Tabs, TabsProps } from 'antd';
import authService from 'core/services/auth';
import { FunctionComponent, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';

const CommitteesMainListPage: FunctionComponent = () => {
	const { t } = useTranslation();
	const navigate = useNavigate();
	const location = useLocation();

	const tabItems: TabsProps['items'] = [
		authService.isPermittedToAction('Committee') && {
			id: '1',
			key: '',
			label: t('ACTIONS.COMMITTEES_STRUCTURE'),
			destroyInactiveTabPane: true,
		},
		authService.isPermittedToAction('CommitteeMeeting') && {
			id: '2',
			key: 'meetings',
			label: t('ACTIONS.COMMITTEES_MEETINGS'),
			destroyInactiveTabPane: true,
		},
		authService.isPermittedToAction('CommitteeMeeting') && {
			id: '3',
			key: 'documents',
			label: t('ACTIONS.COMMITTEES_DOCUMENTS'),
			destroyInactiveTabPane: true,
		},
	].filter(Boolean) as TabsProps['items'];

	const getActiveTab = () => {
		const activeTab = tabItems?.find(
			(tab) => tab.key === (location.pathname.includes('meetings') ? 'meetings' : location.pathname.includes('documents') ? 'documents' : ''),
		);
		if (activeTab) return activeTab?.key;
	};

	useEffect(() => {
		if (!getActiveTab() && tabItems?.length! > 0) {
			navigate(`/dashboard/actions/boards/committees/${tabItems![0]?.key}`);
		}
	}, []);

	return (
		<>
			<Tabs activeKey={getActiveTab()} items={tabItems} size="large" onTabClick={(key) => navigate(`/dashboard/actions/boards/committees/${key}`)} />

			<Outlet />
		</>
	);
};

export default CommitteesMainListPage;
